module.exports = __webpack_public_path__ + "2fe876c23b51ecf6b502f9b990161cc1.png";